import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from '../../shared/dialog/CommonDialog';

export const DeleteSucceededDialog: React.FC = () => {
  const { t } = useTranslation(['dream', 'translation']);
  const title = t('translation:dialog_delete_success');
  const description = t('dialog_delete_success_desc');
  return <CommonDialog title={title} description={description} />;
};
